export default {"src":"/_next/static/media/list_regular.dd98e2ea.svg","height":19,"width":18};